module.exports = __webpack_public_path__ + "img/type-h1.374fe161.svg";